/* BQA TV STREAMFLOW - standalone TV-only build
   Current DWR flow: telemetrystation (latest recorded reading)
   DWR historical: telemetrytimeseriesday
   USGS current/historical and NWS weather unchanged
   Build: 2026-08-11 v3
*/

(function () {
  "use strict";

  var APP_ID = "bqa-tv-streamflow";
  var app = document.getElementById(APP_ID);
  if (!app || app.getAttribute("data-initialized") === "true") return;
  app.setAttribute("data-initialized", "true");
  document.body.classList.add("bqa-tv-streamflow-mode");

  var CONFIG = {
    flowRefreshMs: 15 * 60 * 1000,
    weatherRefreshMs: 60 * 60 * 1000,
    hardReloadMs: 6 * 60 * 60 * 1000,
    flowCacheMaxAgeMs: 6 * 60 * 60 * 1000,
    weatherCacheMaxAgeMs: 6 * 60 * 60 * 1000,
    pointCacheMaxAgeMs: 30 * 24 * 60 * 60 * 1000,
    staleReadingMs: 12 * 60 * 60 * 1000,
    dwrHistoricalYears: 10,
    maxWeatherConcurrency: 4,
    demoMode: /(?:\?|&)demo=1(?:&|$)/.test(window.location.search)
  };

  /*
    This is the only section normally edited when adding, removing, or reordering rivers.
    "historical": USGS period-of-record average is used when available; DWR 10-year average is the fallback.
  */
  var RIVERS = [
    {
      id: "arkansas-salida",
      river: "Arkansas River",
      location: "At Salida",
      usgs: "07093700",
      dwr: "ARKSALCO",
      preferDwr: true,
      lat: 38.5347,
      lon: -105.9989
    },
    {
      id: "bear-morrison",
      river: "Bear Creek",
      location: "At Morrison",
      usgs: "06710500",
      dwr: "BCRMORCO",
      preferDwr: true,
      lat: 39.6536,
      lon: -105.1911
    },
    {
      id: "blue-dillon",
      river: "Blue River",
      location: "Below Dillon Reservoir",
      usgs: "09050700",
      lat: 39.6256,
      lon: -106.0658
    },
    {
      id: "clear-golden",
      river: "Clear Creek",
      location: "At Golden",
      usgs: "06719505",
      lat: 39.7555,
      lon: -105.2211
    },
    {
      id: "colorado-kremmling",
      river: "Colorado River",
      location: "Near Kremmling",
      usgs: "09058000",
      lat: 40.0597,
      lon: -106.3889
    },
    {
      id: "eagle-gypsum",
      river: "Eagle River",
      location: "Below Gypsum",
      usgs: "09070000",
      lat: 39.6469,
      lon: -106.9517
    },
    {
      id: "fryingpan-ruedi",
      river: "Fryingpan River",
      location: "Near Ruedi Reservoir",
      usgs: "09080400",
      lat: 39.3622,
      lon: -106.8167
    },
    {
      id: "roaringfork-glenwood",
      river: "Roaring Fork River",
      location: "At Glenwood Springs",
      usgs: "09085000",
      lat: 39.5505,
      lon: -107.3248
    },
    {
      id: "platte-dream",
      river: "South Platte River",
      location: "Dream Stream",
      dwr: "PLAHARCO",
      preferDwr: true,
      lat: 38.9678,
      lon: -105.5815
    },
    {
      id: "platte-elevenmile",
      river: "South Platte River",
      location: "11 Mile Canyon",
      dwr: "PLAGEOCO",
      preferDwr: true,
      lat: 38.9053,
      lon: -105.4733
    },
    {
      id: "platte-cheesman",
      river: "South Platte River",
      location: "Cheesman Canyon",
      usgs: "06701500",
      dwr: "PLACHECO",
      preferDwr: true,
      lat: 39.2150,
      lon: -105.2780
    },
    {
      id: "platte-deckers",
      river: "South Platte River",
      location: "At Deckers",
      usgs: "06701900",
      lat: 39.2547,
      lon: -105.2272
    },
    {
      id: "northfork-bailey",
      river: "North Fork South Platte",
      location: "At Bailey",
      dwr: "PLABAICO",
      preferDwr: true,
      lat: 39.4050,
      lon: -105.4750
    },
    {
      id: "williamsfork-reservoir",
      river: "Williams Fork River",
      location: "Below Williams Fork Reservoir",
      usgs: "09038500",
      lat: 40.0359,
      lon: -106.2050
    }
  ];

  var state = {
    flowById: {},
    weatherById: {},
    isFlowLoading: false,
    isWeatherLoading: false,
    lastFlowSuccess: null,
    lastWeatherSuccess: null,
    errorCount: 0
  };

  var leftEl = document.getElementById("bqa-tv-left");
  var rightEl = document.getElementById("bqa-tv-right");
  var statusEl = document.getElementById("bqa-tv-status");
  var liveDotEl = document.getElementById("bqa-tv-live-dot");
  var updatedEl = document.getElementById("bqa-tv-updated");

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function pad2(value) {
    return String(value).padStart(2, "0");
  }

  function localDateString(date) {
    return date.getFullYear() + "-" + pad2(date.getMonth() + 1) + "-" + pad2(date.getDate());
  }

  function dateForApi(date) {
    return localDateString(date);
  }

  function startDateForDwr() {
    var d = new Date();
    d.setDate(d.getDate() - 2);
    return dateForApi(d);
  }

  function endDateForDwr() {
    return dateForApi(new Date());
  }

  function formatClock() {
    var now = new Date();
    var time = now.toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit"
    });
    var date = now.toLocaleDateString([], {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric"
    });
    document.getElementById("bqa-tv-clock").textContent = time;
    document.getElementById("bqa-tv-date").textContent = date;
  }

  function safeNumber(value) {
    var n = Number(value);
    if (!Number.isFinite(n) || n <= -999000) return null;
    return n;
  }

  function formatFlow(value) {
    if (value == null || !Number.isFinite(value)) return "--";
    if (value < 10) return value.toFixed(1);
    return Math.round(value).toLocaleString();
  }

  function formatTemp(value) {
    if (value == null || !Number.isFinite(value)) return "--";
    return Math.round(value) + "&deg;";
  }

  function tempClass(value) {
    if (value == null || !Number.isFinite(value)) return "";
    if (value >= 68) return "is-danger";
    if (value >= 66) return "is-caution";
    return "is-good";
  }

  function tempNote(value) {
    if (value == null || !Number.isFinite(value)) return "NO SENSOR";
    if (value >= 68) return "STOP FISHING";
    if (value >= 66) return "USE CAUTION";
    return "DEG F";
  }

  function minutesAgoText(dateValue) {
    if (!dateValue) return "TIME N/A";
    var d = new Date(dateValue);
    if (Number.isNaN(d.getTime())) return "TIME N/A";
    var diffMin = Math.max(0, Math.round((Date.now() - d.getTime()) / 60000));
    if (diffMin < 2) return "JUST UPDATED";
    if (diffMin < 60) return diffMin + " MIN AGO";
    var diffHr = Math.round(diffMin / 60);
    if (diffHr < 24) return diffHr + " HR AGO";
    return d.toLocaleDateString([], { month: "short", day: "numeric" }).toUpperCase();
  }

  function cacheRead(key, maxAgeMs) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return null;
      var item = JSON.parse(raw);
      if (!item || !item.savedAt || typeof item.data === "undefined") return null;
      if (maxAgeMs && Date.now() - item.savedAt > maxAgeMs) return null;
      return item.data;
    } catch (error) {
      return null;
    }
  }

  function cacheWrite(key, data) {
    try {
      localStorage.setItem(key, JSON.stringify({ savedAt: Date.now(), data: data }));
    } catch (error) {
      /* Storage can be unavailable in privacy mode; live operation continues. */
    }
  }

  function fetchJson(url, options) {
    var requestOptions = options || {};
    requestOptions.cache = "no-store";
    return fetch(url, requestOptions).then(function (response) {
      if (!response.ok) throw new Error("HTTP " + response.status + " for " + url);
      return response.json();
    });
  }

  function fetchText(url) {
    return fetch(url).then(function (response) {
      if (!response.ok) throw new Error("HTTP " + response.status + " for " + url);
      return response.text();
    });
  }

  function getUsgsSeriesCode(series) {
    try {
      return String(series.variable.variableCode[0].value || "");
    } catch (error) {
      return "";
    }
  }

  function getUsgsSeriesSite(series) {
    try {
      return String(series.sourceInfo.siteCode[0].value || "");
    } catch (error) {
      return "";
    }
  }

  function newestUsgsValue(data, site, parameterCode) {
    var seriesList = data && data.value && Array.isArray(data.value.timeSeries)
      ? data.value.timeSeries
      : [];
    var best = null;

    seriesList.forEach(function (series) {
      if (getUsgsSeriesSite(series) !== String(site)) return;
      if (getUsgsSeriesCode(series) !== String(parameterCode)) return;

      var valueSets = Array.isArray(series.values) ? series.values : [];
      valueSets.forEach(function (valueSet) {
        var readings = valueSet && Array.isArray(valueSet.value) ? valueSet.value : [];
        readings.forEach(function (reading) {
          var value = safeNumber(reading.value);
          var time = new Date(reading.dateTime || 0).getTime();
          if (value == null || !time) return;
          if (!best || time > best.timeMs) {
            best = {
              value: value,
              time: reading.dateTime,
              timeMs: time,
              siteName: series.sourceInfo && series.sourceInfo.siteName
                ? series.sourceInfo.siteName
                : "",
              latitude: series.sourceInfo && series.sourceInfo.geoLocation && series.sourceInfo.geoLocation.geogLocation
                ? safeNumber(series.sourceInfo.geoLocation.geogLocation.latitude)
                : null,
              longitude: series.sourceInfo && series.sourceInfo.geoLocation && series.sourceInfo.geoLocation.geogLocation
                ? safeNumber(series.sourceInfo.geoLocation.geogLocation.longitude)
                : null
            };
          }
        });
      });
    });

    return best;
  }

  function cToF(value) {
    return (Number(value) * 9 / 5) + 32;
  }

  function normalizeTemperature(value, units) {
    var n = safeNumber(value);
    if (n == null) return null;
    var unitText = String(units || "").toUpperCase();
    if (unitText.indexOf("C") !== -1 && unitText.indexOf("F") === -1) return cToF(n);
    if (!unitText && n < 45) return cToF(n);
    return n;
  }

  function parseUsgsHistoricalRdb(text) {
    var today = new Date();
    var month = today.getMonth() + 1;
    var day = today.getDate();
    var lines = String(text || "").split(/\r?\n/).filter(function (line) {
      return line && line.charAt(0) !== "#";
    });
    if (lines.length < 3) return {};

    var headerIndex = -1;
    for (var i = 0; i < lines.length; i += 1) {
      if (lines[i].indexOf("site_no") !== -1 && lines[i].indexOf("month_nu") !== -1) {
        headerIndex = i;
        break;
      }
    }
    if (headerIndex === -1) return {};

    var headers = lines[headerIndex].split("\t");
    var siteIndex = headers.indexOf("site_no");
    var monthIndex = headers.indexOf("month_nu");
    var dayIndex = headers.indexOf("day_nu");
    var meanIndex = headers.indexOf("mean_va");
    var countIndex = headers.indexOf("count_nu");
    var endYearIndex = headers.indexOf("end_yr");
    if (meanIndex === -1) meanIndex = headers.indexOf("p50_va");
    if (siteIndex === -1 || monthIndex === -1 || dayIndex === -1 || meanIndex === -1) return {};

    var result = {};
    for (var rowIndex = headerIndex + 2; rowIndex < lines.length; rowIndex += 1) {
      var cols = lines[rowIndex].split("\t");
      if (Number(cols[monthIndex]) !== month || Number(cols[dayIndex]) !== day) continue;
      var value = safeNumber(cols[meanIndex]);
      if (value == null) continue;
      var site = String(cols[siteIndex] || "");
      if (!site) continue;
      var candidate = {
        value: value,
        years: countIndex === -1 ? null : safeNumber(cols[countIndex]),
        endYear: endYearIndex === -1 ? null : safeNumber(cols[endYearIndex]),
        label: "P.O.R. AVG"
      };
      var current = result[site];
      if (!current || (candidate.years || 0) > (current.years || 0) ||
        ((candidate.years || 0) === (current.years || 0) && (candidate.endYear || 0) > (current.endYear || 0))) {
        result[site] = candidate;
      }
    }
    return result;
  }

  function extractDwrRows(payload) {
    if (Array.isArray(payload)) return payload;
    if (!payload || typeof payload !== "object") return [];
    return payload.ResultList || payload.resultList || payload.results || payload.Result || [];
  }

  function dwrCode(row) {
    return String(
      row.abbrev || row.Abbrev || row.stationAbbrev || row.stationabbrev ||
      row.stationAbbreviation || row.stationabbreviation || ""
    ).toUpperCase();
  }

  function dwrValue(row) {
    return safeNumber(
      row.measValue != null ? row.measValue :
      row.measvalue != null ? row.measvalue :
      row.value != null ? row.value :
      row.Value != null ? row.Value :
      row.amount
    );
  }

  function dwrDate(row) {
    return row.measDateTime || row.measdatetime ||
      row.measDate || row.measdate ||
      row.dateTime || row.datetime ||
      row.date || row.Date || null;
  }

  function dwrUnits(row) {
    return row.measUnit || row.measunit || row.units || row.unit || row.Unit || "";
  }

  function dwrParameter(row) {
    return String(row.parameter || row.Parameter || row.measType || row.meastype || "").toUpperCase();
  }

  function newestDwrByCode(payload, isTemperature) {
    var rows = extractDwrRows(payload);
    var result = {};
    rows.forEach(function (row) {
      var code = dwrCode(row);
      var value = dwrValue(row);
      var date = dwrDate(row);
      var timeMs = new Date(date || 0).getTime();
      if (!code || value == null || !timeMs) return;
      var normalized = isTemperature ? normalizeTemperature(value, dwrUnits(row)) : value;
      if (normalized == null) return;
      if (!result[code] || timeMs > result[code].timeMs) {
        result[code] = {
          value: normalized,
          time: date,
          timeMs: timeMs,
          units: dwrUnits(row)
        };
      }
    });
    return result;
  }

  function buildDwrUrl(endpoint, codes, parameter, startDate, endDate, pageSize) {
    var params = new URLSearchParams({
      format: "json",
      abbrev: codes.join(","),
      parameter: parameter,
      startDate: startDate,
      endDate: endDate,
      pageSize: String(pageSize || 5000)
    });
    return "https://dwr.state.co.us/Rest/GET/api/v2/telemetrystations/" + endpoint + "/?" + params.toString();
  }

  /*
    CURRENT DWR READINGS
    --------------------
    For the TV board we use telemetrystation rather than the hourly
    aggregation endpoint. Colorado DWR documents telemetrystation as
    returning stations and their most recent parameter reading.

    Historical averages still use telemetrytimeseriesday below.
  */

  function buildDwrLatestUrl(codes, parameter) {
    var params = new URLSearchParams({
      format: "json",
      abbrev: codes.join(","),
      parameter: parameter,
      pageSize: "1000"
    });

    return "https://dwr.state.co.us/Rest/GET/api/v2/telemetrystations/telemetrystation/?" +
      params.toString();
  }

  function parseDwrLatest(payload, isTemperature) {
    var rows = extractDwrRows(payload);
    var result = {};

    rows.forEach(function (row) {
      var code = dwrCode(row);
      var parameter = dwrParameter(row);
      var value = dwrValue(row);
      var date = dwrDate(row);
      var timeMs = new Date(date || 0).getTime();

      if (!code || value == null || !timeMs) return;

      if (isTemperature) {
        if (parameter && parameter !== "WATTEMP" && parameter.indexOf("TEMP") === -1) return;
        value = normalizeTemperature(value, dwrUnits(row));
      } else {
        if (parameter && parameter !== "DISCHRG") return;
      }

      if (value == null) return;

      if (!result[code] || timeMs > result[code].timeMs) {
        result[code] = {
          value: value,
          time: date,
          timeMs: timeMs,
          units: dwrUnits(row)
        };
      }
    });

    return result;
  }

  function fetchDwrLatestGroup(codes, parameter) {
    if (!codes.length) return Promise.resolve({});

    var url = buildDwrLatestUrl(codes, parameter);

    return fetchJson(url).then(function (payload) {
      return parseDwrLatest(payload, parameter === "WATTEMP");
    });
  }

  function fetchDwrLatestOne(code, parameter) {
    var url = buildDwrLatestUrl([code], parameter);

    return fetchJson(url)
      .then(function (payload) {
        return parseDwrLatest(payload, parameter === "WATTEMP");
      })
      .then(function (result) {
        return result;
      });
  }

  function fetchDwrLatestWithFallback(codes, parameter) {
    if (!codes.length) return Promise.resolve({});

    /*
      First try one efficient grouped call. If DWR rejects a grouped
      request for any reason, fall back to one request per station.
    */
    return fetchDwrLatestGroup(codes, parameter)
      .then(function (result) {
        var missing = codes.filter(function (code) {
          return !result[String(code).toUpperCase()];
        });

        if (!missing.length) return result;

        return Promise.all(
          missing.map(function (code) {
            return fetchDwrLatestOne(code, parameter)
              .catch(function () { return {}; });
          })
        ).then(function (parts) {
          parts.forEach(function (part) {
            Object.keys(part).forEach(function (code) {
              result[code] = part[code];
            });
          });
          return result;
        });
      })
      .catch(function () {
        return Promise.all(
          codes.map(function (code) {
            return fetchDwrLatestOne(code, parameter)
              .catch(function () { return {}; });
          })
        ).then(function (parts) {
          var result = {};
          parts.forEach(function (part) {
            Object.keys(part).forEach(function (code) {
              result[code] = part[code];
            });
          });
          return result;
        });
      });
  }

  function fetchDwrCurrentBundle(codes) {
    if (!codes.length) return Promise.resolve({ flow: {}, temp: {} });

    return Promise.all([
      fetchDwrLatestWithFallback(codes, "DISCHRG").catch(function () { return {}; }),
      fetchDwrLatestWithFallback(codes, "WATTEMP").catch(function () { return {}; })
    ]).then(function (parts) {
      return {
        flow: parts[0],
        temp: parts[1]
      };
    });
  }

  function sameMonthDayInYear(year) {
    var now = new Date();
    var month = now.getMonth();
    var day = now.getDate();
    var d = new Date(year, month, day);
    if (d.getMonth() !== month) d = new Date(year, month, day - 1);
    return localDateString(d);
  }

  function fetchDwrHistorical(codes) {
    if (!codes.length) return Promise.resolve({});
    var cacheKey = "bqaTvDwrHistorical:v3:" + localDateString(new Date()) + ":" + codes.join("-");
    var cached = cacheRead(cacheKey, 30 * 60 * 60 * 1000);
    if (cached) return Promise.resolve(cached);

    var currentYear = new Date().getFullYear();
    var requests = [];
    for (var offset = 1; offset <= CONFIG.dwrHistoricalYears; offset += 1) {
      var date = sameMonthDayInYear(currentYear - offset);
      var url = buildDwrUrl("telemetrytimeseriesday", codes, "DISCHRG", date, date, 1000);
      requests.push(fetchJson(url).catch(function () { return null; }));
    }

    return Promise.all(requests).then(function (payloads) {
      var buckets = {};
      payloads.forEach(function (payload) {
        if (!payload) return;
        extractDwrRows(payload).forEach(function (row) {
          var code = dwrCode(row);
          var value = dwrValue(row);
          if (!code || value == null) return;
          if (!buckets[code]) buckets[code] = [];
          buckets[code].push(value);
        });
      });

      var result = {};
      Object.keys(buckets).forEach(function (code) {
        var values = buckets[code];
        if (!values.length) return;
        result[code] = {
          value: values.reduce(function (sum, value) { return sum + value; }, 0) / values.length,
          years: values.length,
          label: values.length + " YR AVG"
        };
      });
      cacheWrite(cacheKey, result);
      return result;
    });
  }

  function fetchUsgsCurrent(sites) {
    if (!sites.length) return Promise.resolve(null);
    var params = new URLSearchParams({
      format: "json",
      sites: sites.join(","),
      parameterCd: "00060,00010",
      siteStatus: "all",
      period: "P2D"
    });
    return fetchJson("https://waterservices.usgs.gov/nwis/iv/?" + params.toString());
  }

  function fetchUsgsHistorical(sites) {
    if (!sites.length) return Promise.resolve({});
    var cacheKey = "bqaTvUsgsHistorical:v3:" + localDateString(new Date()) + ":" + sites.join("-");
    var cached = cacheRead(cacheKey, 30 * 60 * 60 * 1000);
    if (cached) return Promise.resolve(cached);

    /* The USGS statistics service accepts no more than 10 sites per request. */
    var chunks = [];
    for (var i = 0; i < sites.length; i += 10) chunks.push(sites.slice(i, i + 10));

    var requests = chunks.map(function (chunk) {
      var params = new URLSearchParams({
        format: "rdb",
        sites: chunk.join(","),
        parameterCd: "00060",
        statReportType: "daily",
        statType: "mean"
      });
      return fetchText("https://waterservices.usgs.gov/nwis/stat/?" + params.toString())
        .then(parseUsgsHistoricalRdb)
        .catch(function () { return {}; });
    });

    return Promise.all(requests).then(function (parts) {
      var result = {};
      parts.forEach(function (part) {
        Object.keys(part).forEach(function (site) { result[site] = part[site]; });
      });
      cacheWrite(cacheKey, result);
      return result;
    });
  }

  function uniqueValues(values) {
    return values.filter(function (value, index, arr) {
      return value && arr.indexOf(value) === index;
    });
  }

  function mergeLiveFlowData(usgsPayload, usgsHistorical, dwrFlow, dwrTemp, dwrHistorical) {
    var results = {};

    RIVERS.forEach(function (river) {
      var usgsFlow = river.usgs ? newestUsgsValue(usgsPayload, river.usgs, "00060") : null;
      var usgsTemp = river.usgs ? newestUsgsValue(usgsPayload, river.usgs, "00010") : null;
      var dwrFlowValue = river.dwr ? dwrFlow[String(river.dwr).toUpperCase()] : null;
      var dwrTempValue = river.dwr ? dwrTemp[String(river.dwr).toUpperCase()] : null;

      var current = null;
      if (river.preferDwr && dwrFlowValue) {
        current = { value: dwrFlowValue.value, time: dwrFlowValue.time, source: "CO DWR" };
      } else if (usgsFlow) {
        current = { value: usgsFlow.value, time: usgsFlow.time, source: "USGS" };
      } else if (dwrFlowValue) {
        current = { value: dwrFlowValue.value, time: dwrFlowValue.time, source: "CO DWR" };
      }

      var temperature = null;
      var tempTime = null;
      var tempSource = null;
      if (usgsTemp) {
        temperature = cToF(usgsTemp.value);
        tempTime = usgsTemp.time;
        tempSource = "USGS";
      } else if (dwrTempValue) {
        temperature = dwrTempValue.value;
        tempTime = dwrTempValue.time;
        tempSource = "CO DWR";
      }

      var historical = river.usgs && usgsHistorical[river.usgs]
        ? usgsHistorical[river.usgs]
        : null;
      if (!historical && river.dwr && dwrHistorical[String(river.dwr).toUpperCase()]) {
        historical = dwrHistorical[String(river.dwr).toUpperCase()];
      }

      if (!current) {
        var cached = cacheRead("bqaTvFlow:v3:" + river.id, CONFIG.flowCacheMaxAgeMs);
        if (cached) {
          cached.cached = true;
          results[river.id] = cached;
          return;
        }
      }

      var item = {
        current: current ? current.value : null,
        currentTime: current ? current.time : null,
        source: current ? current.source : "UNAVAILABLE",
        historical: historical ? historical.value : null,
        historicalLabel: historical ? historical.label : "NO HISTORY",
        historicalYears: historical ? historical.years : null,
        tempF: temperature,
        tempTime: tempTime,
        tempSource: tempSource,
        cached: false
      };

      if (current) cacheWrite("bqaTvFlow:v3:" + river.id, item);
      results[river.id] = item;
    });

    return results;
  }

  function createDemoFlow() {
    var current = [1120, 31, 188, 72, 1430, 238, 201, 418, 146, 169, 317, 325, 42, 247];
    var historical = [890, 44, 156, 91, 1250, 290, 184, 560, 211, 206, 274, 289, 54, 139];
    var temperatures = [63, 64, 51, 66.4, 67.2, 68.4, 44, 69.1, 57, 54, 55, 61, null, 50];
    var result = {};
    RIVERS.forEach(function (river, index) {
      result[river.id] = {
        current: current[index],
        currentTime: new Date(Date.now() - (index % 4) * 14 * 60000).toISOString(),
        source: river.dwr && river.preferDwr ? "CO DWR" : "USGS",
        historical: historical[index],
        historicalLabel: river.dwr && !river.usgs ? "10 YR AVG" : "P.O.R. AVG",
        historicalYears: river.dwr && !river.usgs ? 10 : 38,
        tempF: temperatures[index],
        tempTime: new Date().toISOString(),
        tempSource: temperatures[index] == null ? null : (river.dwr && !river.usgs ? "CO DWR" : "USGS"),
        cached: false
      };
    });
    return result;
  }

  function loadFlowData() {
    if (state.isFlowLoading) return Promise.resolve();
    state.isFlowLoading = true;
    setStatus("UPDATING RIVER DATA", "loading");

    if (CONFIG.demoMode) {
      state.flowById = createDemoFlow();
      state.lastFlowSuccess = new Date();
      state.isFlowLoading = false;
      renderAll();
      setStatus("DEMO DISPLAY", "ok");
      return Promise.resolve();
    }

    var usgsSites = uniqueValues(RIVERS.map(function (river) { return river.usgs; }));
    var dwrCodes = uniqueValues(RIVERS.map(function (river) { return river.dwr; }));

    return Promise.all([
      fetchUsgsCurrent(usgsSites).catch(function () { return null; }),
      fetchUsgsHistorical(usgsSites).catch(function () { return {}; }),
      fetchDwrCurrentBundle(dwrCodes).catch(function () { return { flow: {}, temp: {} }; }),
      fetchDwrHistorical(dwrCodes).catch(function () { return {}; })
    ]).then(function (parts) {
      state.flowById = mergeLiveFlowData(parts[0], parts[1], parts[2].flow, parts[2].temp, parts[3]);
      state.lastFlowSuccess = new Date();
      state.errorCount = RIVERS.filter(function (river) {
        var item = state.flowById[river.id];
        return !item || item.current == null;
      }).length;
      renderAll();
      setStatus(state.errorCount ? "LIVE WITH " + state.errorCount + " DATA GAP" + (state.errorCount === 1 ? "" : "S") : "LIVE DATA", state.errorCount ? "warning" : "ok");
    }).catch(function () {
      state.errorCount = RIVERS.length;
      renderAll();
      setStatus("DATA CONNECTION ISSUE", "warning");
    }).finally(function () {
      state.isFlowLoading = false;
      updateFooter();
    });
  }

  function weatherSymbol(shortForecast) {
    var text = String(shortForecast || "").toLowerCase();
    if (/thunder|storm/.test(text)) return "&#9889;";
    if (/snow|sleet|ice|blizzard/.test(text)) return "&#10052;";
    if (/rain|shower|drizzle/.test(text)) return "&#9730;";
    if (/fog|haze|smoke/.test(text)) return "&#8801;";
    if (/cloud|overcast/.test(text)) return "&#9729;";
    if (/partly|mostly sunny|mostly clear/.test(text)) return "&#9925;";
    return "&#9728;";
  }

  function extractThreeDayForecast(payload) {
    var periods = payload && payload.properties && Array.isArray(payload.properties.periods)
      ? payload.properties.periods
      : [];
    var days = [];

    for (var i = 0; i < periods.length && days.length < 3; i += 1) {
      var daytime = periods[i];
      if (!daytime.isDaytime) continue;
      var nighttime = null;
      for (var j = i + 1; j < periods.length; j += 1) {
        if (periods[j].isDaytime) break;
        nighttime = periods[j];
        break;
      }
      days.push({
        date: daytime.startTime,
        high: safeNumber(daytime.temperature),
        low: nighttime ? safeNumber(nighttime.temperature) : null,
        icon: daytime.icon || "",
        shortForecast: daytime.shortForecast || "Forecast"
      });
    }
    return days;
  }

  function nwsHeaders() {
    return { Accept: "application/geo+json" };
  }

  function fetchNwsForecastForRiver(river) {
    var weatherCacheKey = "bqaTvWeather:v3:" + river.id;
    var pointKey = river.lat.toFixed(4) + "," + river.lon.toFixed(4);
    var pointCacheKey = "bqaTvNwsPoint:v2:" + pointKey;
    var pointCache = cacheRead(pointCacheKey, CONFIG.pointCacheMaxAgeMs);

    function getForecastUrl() {
      if (pointCache && pointCache.forecastUrl) return Promise.resolve(pointCache.forecastUrl);
      return fetchJson("https://api.weather.gov/points/" + pointKey, { headers: nwsHeaders() })
        .then(function (payload) {
          var forecastUrl = payload && payload.properties ? payload.properties.forecast : null;
          if (!forecastUrl) throw new Error("NWS forecast URL unavailable");
          cacheWrite(pointCacheKey, { forecastUrl: forecastUrl });
          return forecastUrl;
        });
    }

    return getForecastUrl()
      .then(function (forecastUrl) {
        return fetchJson(forecastUrl, { headers: nwsHeaders() });
      })
      .then(function (payload) {
        var days = extractThreeDayForecast(payload);
        if (!days.length) throw new Error("NWS periods unavailable");
        var result = { days: days, cached: false, updatedAt: new Date().toISOString() };
        cacheWrite(weatherCacheKey, result);
        return result;
      })
      .catch(function (error) {
        var cached = cacheRead(weatherCacheKey, CONFIG.weatherCacheMaxAgeMs);
        if (cached) {
          cached.cached = true;
          return cached;
        }
        return { days: [], cached: false, error: true, updatedAt: null };
      });
  }

  function mapLimit(items, limit, worker) {
    var results = new Array(items.length);
    var nextIndex = 0;

    function runOne() {
      var index = nextIndex;
      nextIndex += 1;
      if (index >= items.length) return Promise.resolve();
      return Promise.resolve(worker(items[index], index))
        .then(function (result) { results[index] = result; })
        .then(runOne);
    }

    var workers = [];
    var workerCount = Math.min(limit, items.length);
    for (var i = 0; i < workerCount; i += 1) workers.push(runOne());
    return Promise.all(workers).then(function () { return results; });
  }

  function createDemoWeather() {
    var forecasts = [
      ["Sunny", 78, 47],
      ["Partly Sunny", 75, 45],
      ["Scattered Thunderstorms", 71, 44]
    ];
    var result = {};
    RIVERS.forEach(function (river, riverIndex) {
      result[river.id] = {
        cached: false,
        updatedAt: new Date().toISOString(),
        days: forecasts.map(function (item, dayIndex) {
          var d = new Date();
          d.setDate(d.getDate() + dayIndex);
          return {
            date: d.toISOString(),
            high: item[1] - (riverIndex % 5),
            low: item[2] - (riverIndex % 4),
            icon: "",
            shortForecast: item[0]
          };
        })
      };
    });
    return result;
  }

  function loadWeatherData() {
    if (state.isWeatherLoading) return Promise.resolve();
    state.isWeatherLoading = true;

    if (CONFIG.demoMode) {
      state.weatherById = createDemoWeather();
      state.lastWeatherSuccess = new Date();
      state.isWeatherLoading = false;
      renderAll();
      updateFooter();
      return Promise.resolve();
    }

    return mapLimit(RIVERS, CONFIG.maxWeatherConcurrency, fetchNwsForecastForRiver)
      .then(function (weatherItems) {
        weatherItems.forEach(function (item, index) {
          state.weatherById[RIVERS[index].id] = item;
        });
        state.lastWeatherSuccess = new Date();
        renderAll();
      })
      .finally(function () {
        state.isWeatherLoading = false;
        updateFooter();
      });
  }

  function dayLabel(dateValue) {
    var date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return "DAY";
    return date.toLocaleDateString([], { weekday: "short" }).toUpperCase();
  }

  function weatherDayHtml(day) {
    var iconHtml;
    if (day.icon) {
      var safeIcon = escapeHtml(day.icon);
      var fallback = weatherSymbol(day.shortForecast);
      iconHtml = '<img class="bqa-tv-weather-icon" src="' + safeIcon + '" alt="' + escapeHtml(day.shortForecast) + '" referrerpolicy="no-referrer" onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'grid\';">' +
        '<span class="bqa-tv-weather-symbol" style="display:none">' + fallback + "</span>";
    } else {
      iconHtml = '<span class="bqa-tv-weather-symbol">' + weatherSymbol(day.shortForecast) + "</span>";
    }

    var high = day.high == null ? "--" : Math.round(day.high) + "&deg;";
    var low = day.low == null ? "--" : Math.round(day.low) + "&deg;";
    return (
      '<div class="bqa-tv-weather-day" title="' + escapeHtml(day.shortForecast) + '">' +
        '<div class="bqa-tv-weather-label">' + dayLabel(day.date) + "</div>" +
        '<div class="bqa-tv-weather-icon-wrap">' + iconHtml + "</div>" +
        '<div class="bqa-tv-weather-temps"><div>' + high + '</div><div class="low">' + low + "</div></div>" +
      "</div>"
    );
  }

  function weatherHtml(weather) {
    if (!weather || !Array.isArray(weather.days) || !weather.days.length) {
      return '<div class="bqa-tv-weather"><div class="bqa-tv-weather-unavailable">FORECAST UNAVAILABLE</div></div>';
    }
    return '<div class="bqa-tv-weather">' + weather.days.slice(0, 3).map(weatherDayHtml).join("") + "</div>";
  }

  function loadingRowHtml(river) {
    return (
      '<div class="bqa-tv-row">' +
        '<div class="bqa-tv-river">' +
          '<div class="bqa-tv-river-name">' + escapeHtml(river.river) + "</div>" +
          '<div class="bqa-tv-location">' + escapeHtml(river.location) + "</div>" +
          '<div class="bqa-tv-source"><span class="bqa-tv-loading-line short"></span></div>' +
        "</div>" +
        '<div class="bqa-tv-metric"><span class="bqa-tv-loading-line"></span></div>' +
        '<div class="bqa-tv-metric"><span class="bqa-tv-loading-line"></span></div>' +
        '<div class="bqa-tv-metric"><span class="bqa-tv-loading-line"></span></div>' +
        '<div class="bqa-tv-weather"><span class="bqa-tv-loading-line"></span><span class="bqa-tv-loading-line"></span><span class="bqa-tv-loading-line"></span></div>' +
      "</div>"
    );
  }

  function rowHtml(river) {
    var flow = state.flowById[river.id];
    var weather = state.weatherById[river.id];
    if (!flow) return loadingRowHtml(river);

    var readingAge = flow.currentTime ? Date.now() - new Date(flow.currentTime).getTime() : null;
    var stale = readingAge != null && readingAge > CONFIG.staleReadingMs;
    var rowClasses = ["bqa-tv-row"];
    if (stale) rowClasses.push("is-stale");
    if (flow.cached) rowClasses.push("is-cached");

    var sourceLine = flow.source;
    if (flow.currentTime) sourceLine += " / " + minutesAgoText(flow.currentTime);
    if (flow.cached) sourceLine += " / CACHED";
    else if (stale) sourceLine += " / STALE";

    var historyNote = flow.historicalLabel || "NO HISTORY";
    var temperatureClass = tempClass(flow.tempF);
    var tempSourceNote = tempNote(flow.tempF);
    if (flow.tempF != null && flow.tempSource) tempSourceNote += " / " + flow.tempSource;
    if (flow.tempF != null && flow.tempTime) {
      var tempAge = Date.now() - new Date(flow.tempTime).getTime();
      if (tempAge > CONFIG.staleReadingMs) tempSourceNote += " / STALE";
    }

    return (
      '<div class="' + rowClasses.join(" ") + '">' +
        '<div class="bqa-tv-river">' +
          '<div class="bqa-tv-river-name">' + escapeHtml(river.river) + "</div>" +
          '<div class="bqa-tv-location">' + escapeHtml(river.location) + "</div>" +
          '<div class="bqa-tv-source">' + escapeHtml(sourceLine) + "</div>" +
        "</div>" +
        '<div class="bqa-tv-metric bqa-tv-current">' +
          '<div class="bqa-tv-number' + (flow.current == null ? " bqa-tv-no-data" : "") + '">' + formatFlow(flow.current) + "</div>" +
          '<div class="bqa-tv-unit">CFS</div>' +
        "</div>" +
        '<div class="bqa-tv-metric bqa-tv-history">' +
          '<div class="bqa-tv-number' + (flow.historical == null ? " bqa-tv-no-data" : "") + '">' + formatFlow(flow.historical) + "</div>" +
          '<div class="bqa-tv-metric-note">' + escapeHtml(historyNote) + "</div>" +
        "</div>" +
        '<div class="bqa-tv-metric bqa-tv-temp ' + temperatureClass + '">' +
          '<div class="bqa-tv-number' + (flow.tempF == null ? " bqa-tv-no-data" : "") + '">' + formatTemp(flow.tempF) + "</div>" +
          '<div class="bqa-tv-metric-note">' + escapeHtml(tempSourceNote) + "</div>" +
        "</div>" +
        weatherHtml(weather) +
      "</div>"
    );
  }

  function renderAll() {
    var midpoint = Math.ceil(RIVERS.length / 2);
    leftEl.innerHTML = RIVERS.slice(0, midpoint).map(rowHtml).join("");
    rightEl.innerHTML = RIVERS.slice(midpoint).map(rowHtml).join("");
    updateFooter();
  }

  function setStatus(text, type) {
    statusEl.textContent = text;
    liveDotEl.classList.remove("is-loading", "has-errors");
    if (type === "loading") liveDotEl.classList.add("is-loading");
    if (type === "warning") liveDotEl.classList.add("has-errors");
  }

  function updateFooter() {
    var parts = [];
    if (state.lastFlowSuccess) {
      parts.push("RIVERS " + state.lastFlowSuccess.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }));
    }
    if (state.lastWeatherSuccess) {
      parts.push("WEATHER " + state.lastWeatherSuccess.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }));
    }
    if (CONFIG.demoMode) parts.push("DEMO MODE");
    updatedEl.textContent = parts.length ? "UPDATED: " + parts.join(" / ") : "STARTING LIVE UPDATE...";
  }

  function initialRender() {
    state.flowById = {};
    state.weatherById = {};
    renderAll();
  }

  function requestFullScreen() {
    var target = document.documentElement;
    if (!document.fullscreenElement && target.requestFullscreen) {
      target.requestFullscreen().catch(function () {});
    }
  }

  document.addEventListener("keydown", function (event) {
    var key = String(event.key || "").toLowerCase();
    if (key === "r") {
      loadFlowData();
      loadWeatherData();
    }
    if (key === "f") requestFullScreen();
  });

  app.addEventListener("dblclick", requestFullScreen);

  formatClock();
  initialRender();
  loadFlowData();
  loadWeatherData();

  setInterval(formatClock, 30 * 1000);
  setInterval(loadFlowData, CONFIG.flowRefreshMs);
  setInterval(loadWeatherData, CONFIG.weatherRefreshMs);
  setTimeout(function () { window.location.reload(); }, CONFIG.hardReloadMs);
})();